// extracted by css-extract-rspack-plugin
module.exports =  {"page-clock":"Clock-bHFE__page-clock"};